import { mediaCategoriesConstants } from '@abroad/components'

const mediaLibrary = {
  mediaCategories: [...mediaCategoriesConstants],
}
export default mediaLibrary
